import InternalCard from './Card';
import Grid from './Grid';
import Meta from './Meta';
const Card = InternalCard;
Card.Grid = Grid;
Card.Meta = Meta;
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}
export default Card;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/card/index.js
// module id = 1603
// module chunks = 0